export const ru = {
    'preview-cancel': 'Отмена',
    'preview-select': 'Выбрать'
};
